<section class="content-header">
  <div
    class="container-fluid d-flex justify-content-center align-items-center container-height">
    <div class="container">
      <div class="error-container">
        <h1>403</h1>
        <i class="fas fa-lock" style="font-size: 50px"></i>

        <p>Access Denied</p>
        <span
          (keyup.enter)="goHome()"
          tabindex="0"
          class="home-button pointer"
          (click)="goHome()"
          >Go Home</span
        >
      </div>
    </div>
  </div>
</section>
